import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
var DeviceApplicationListView = /** @class */ (function (_super) {
    tslib_1.__extends(DeviceApplicationListView, _super);
    function DeviceApplicationListView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.application = null;
        return _this;
    }
    DeviceApplicationListView.prototype.routed = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.application = this.product.applications.find(function (a) { return a.applicationId == params.applicationId; });
                if (!this.application) {
                    this.$router.replace("/devices/" + this.device.serial + "/applications");
                    return [2 /*return*/];
                }
                return [2 /*return*/];
            });
        });
    };
    tslib_1.__decorate([
        Prop({ type: Object }),
        tslib_1.__metadata("design:type", Object)
    ], DeviceApplicationListView.prototype, "device", void 0);
    tslib_1.__decorate([
        Prop({ type: Object }),
        tslib_1.__metadata("design:type", Object)
    ], DeviceApplicationListView.prototype, "product", void 0);
    DeviceApplicationListView = tslib_1.__decorate([
        Component
    ], DeviceApplicationListView);
    return DeviceApplicationListView;
}(Vue));
export default DeviceApplicationListView;
